import React, { useState, useEffect } from "react";

import Modal from '../../shared/components/modal';
import { Helpers } from '../../core/src/helpers';

import '../css/exit-popup.less';

const DEFAULT_BACKGROUND_IMG = 'https://www.hp.com/us-en/shop/app/assets/images/uploads/dev/HP-TT-Exit-intent-pop-up-art1617147732976194.png';
const DEFAULT_HEIGHT = 300;
const DEFAULT_WIDTH = 500;
const DEFAULT_CTA_LINK = '/us-en/shop/slp/weekly-deals';
const DEFAULT_CTA_TEXT = 'Shop now';
const DEFAULT_LINE_ONE = 'Before you go...';
const DEFAULT_LINE_TWO = 'Check out top deals from HP';
const DEFAULT_MESSAGE = 'Plus, get free shipping and easy returns';

const ExitPopup = ({ exitPopup, shouldOpenPopup }) => {
    const { 
        backgroundImgUrl=DEFAULT_BACKGROUND_IMG, 
        ctaLink=DEFAULT_CTA_LINK, 
        ctaText=DEFAULT_CTA_TEXT, 
        customCSS, 
        titleLineOne=DEFAULT_LINE_ONE, 
        titleLineTwo=DEFAULT_LINE_TWO,
        message=DEFAULT_MESSAGE,
        width=DEFAULT_WIDTH,
        height=DEFAULT_HEIGHT
    } = exitPopup;
    const [mouseLeft, setMouseLeft] = useState(false);
    const [triggered, setTriggered] = useState(false);

    useEffect(() => {
        document.addEventListener('mouseleave', onExit);
        return () => document.removeEventListener('mouseleave', onExit);
    }, [mouseLeft, triggered]);

    const onExit = () => {
        let shouldOpen = typeof shouldOpenPopup === 'function' && shouldOpenPopup();
        if(!mouseLeft && !triggered && shouldOpen){
            setMouseLeft(true);
            setTriggered(true);
            return;
        }

        const opened = window.sessionStorage.getItem('epOpened');
        if (!shouldOpenPopup && !mouseLeft && !triggered && !opened) {
            setMouseLeft(true);
            setTriggered(true);
            window.sessionStorage.setItem('epOpened', true);
        }
    }

    const closeModal = () => {
        setMouseLeft(false);
    }

    const styles = { 
        backgroundImage: `url(${backgroundImgUrl})`,
        width: parseInt(width),
        height: parseInt(height)
    };

    return (
        <Modal isOpen={mouseLeft} closeModal={closeModal} className='exit-popup'>
            <style dangerouslySetInnerHTML={Helpers.createMarkup(customCSS)}></style>
            <div className='exit-popup-wrapper' style={styles}>
                <div className='content'>
                    <h1 className='line-1'>{titleLineOne}</h1>
                    <h1 className='line-2'>{titleLineTwo}</h1>
                    <a className='cta' href={ctaLink}>{ctaText}</a>
                    <p className='msg'>{message}</p>
                </div>
            </div>
        </Modal>
    );
}

export default ExitPopup;